import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Divider() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.05, 1.15]);

  return (
    <section
      ref={ref}
      data-testid="divider"
      className="relative h-[75vh] w-full overflow-hidden bg-[#1A1A18]"
    >
      <motion.img
        style={{ y, scale }}
        src="https://images.pexels.com/photos/12217851/pexels-photo-12217851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000"
        alt="California coastal landscape"
        className="absolute inset-0 h-[120%] w-full object-cover opacity-80 will-change-transform"
        draggable="false"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A18]/70 via-transparent to-[#1A1A18]/30" />

      <div className="relative z-10 mx-auto flex h-full max-w-[1440px] flex-col justify-between px-6 sm:px-10 py-16">
        <div className="flex items-center justify-between text-[#F7F5F0]/80">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em]">
            (Interlude)
          </span>
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em]">
            Big Sur, CA · 36.2°N
          </span>
        </div>

        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-[22ch] font-serif-display font-light italic tracking-tight text-[#F7F5F0] text-4xl sm:text-6xl lg:text-7xl leading-[1]"
        >
          “Between stimulus and response, there is a space.”
        </motion.blockquote>

        <div className="flex items-end justify-between text-[#F7F5F0]/70">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em]">
            — Viktor E. Frankl
          </span>
          <span className="font-serif-display italic text-[#F7F5F0] text-xl">
            Fig. 02 — Stillness
          </span>
        </div>
      </div>
    </section>
  );
}
